import React from 'react';
import { Alert, Box, Markdown } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './DealerCardsList.style';

const DealerResultContainer = themeStyles.apply(Box, 'DealerResultContainer');
const ResultMessage = themeStyles.apply(Markdown, 'ResultMessage');

const DealerNoResultAlert = () => {
  const { t } = useTranslation();
  return (
    <DealerResultContainer data-testid="cy-dealer-no-result-alert">
      <Alert
        variant="info"
        iconName="warning"
        iconColor="black"
        iconSize="large"
        iconStyle={{ filled: true }}
        bg="white"
      >
        <ResultMessage>{t('Sub-apps.Dealers.noDealersError')}</ResultMessage>
      </Alert>
    </DealerResultContainer>
  );
};

export default DealerNoResultAlert;
